<!-- ./pages/Index.vue -->
<template>
  <ul>
    <div class="help">
    <h2>About</h2>
      ビル・ジェームズの提唱した「類似性スコア」の高い選手を検索するwebアプリです。<br><br>
      <b>選手名を入力</b>ボックスに実在する選手の名前を入力するとその選手の成績を代入します。<br>横の<b>ランダム</b>を押すと選手をランダムで選択して入力します。<br>
      <br>
      成績を入力したら<b>類似選手検索</b>ボタンを押してみましょう。<br>
      その成績と似ている選手が表示されるはずです（ただし、スコアが高い選手が少なすぎると誰も引っかかりません）。<br>
      検索結果から選手名をクリックするとその選手の成績を上のフォームに代入します。<br><br>
      <h2>計算式</h2>
      年度成績の場合、成績入力の下部のタブをクリックすることで計算方法を選択できます。<br>
      <b>通常</b>は本家のものをそのまま使用して計算します。<br>
      （参考：<a href="https://ja.wikipedia.org/wiki/%E9%A1%9E%E4%BC%BC%E6%80%A7%E3%82%B9%E3%82%B3%E3%82%A2">https://ja.wikipedia.org/wiki/類似性スコア</a>）<br><br>
      <b>オリジナル</b>は独自の計算式を用います。こちらは投手はFIPをベースにし、野手は守備の出場試合数を考慮します。<br>
      また、それぞれ年齢と利き腕も計算式に含まれます。<br><br><br>
      <div class="form-row col-md-20">
        <span v-for="l in list" v-bind:key="l.id">
        <router-link :to="{ name: 'similarity', params: { id: l.id }}">
          <button  v-if="l.id[0]==='b'" class="buttonb" type="submit">{{ l.title }}</button>
          <button  v-if="l.id[0]==='p'" class="buttonp" type="submit">{{ l.title }}</button>
          </router-link>
        </span>
      </div>
    </div>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['list'])
  }
}
</script>
<style scoped>
button {

  /* 縦方向に10px、
  * 横方向に30pxの余白を指定 */
  padding: 10px 30px;

  /* 文字色を白色に指定 */
  color: #fff;

  /* ボーダーをなくす */
  border-style: none;

  /* 角丸の指定 */
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

button:hover {
  /* 透明度を20%に指定 */
  opacity: 0.8;
}
button.buttonb {
  background-color: #003d42;
}
button.buttonp {
  background-color: #50053c;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue